import React, { useState, useEffect, useRef } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

function SearchBox({ searchFunction, resetParent, autoFocus=false, triggerClearInput = null }) {
    const [keywords, setKeywords] = useState("");
    const prevKeywords = useRef("");

    const clearInput = () => {
        setKeywords("");
        resetParent();
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setKeywords(value);

        if (value.trim() === "") {
            clearInput(); // call reset when input becomes empty
        }
        };

    useEffect(() => {
        // Skip if value hasn't changed
        if (keywords === prevKeywords.current) return;

        // 🔑 Only fire if 2+ characters
        if (keywords.trim().length < 2) return;

        // Update ref
        prevKeywords.current = keywords;

        // Skip if empty
        if (!keywords.trim()) return;

        // Optional: only search if 2+ characters
        if (keywords.trim().length < 2) return;

        const delayDebounce = setTimeout(() => {
        searchFunction(1, keywords);
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [keywords, searchFunction]);

    useEffect(() => {
      if (triggerClearInput) clearInput();  
    }, [triggerClearInput]);

    return (
        <Paper
        component="div"
        elevation={0}
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', border: '1px solid #ccc' }}
        >
        <InputBase
            autoFocus={autoFocus}
            sx={{ ml: 1, flex: 1, mt: -0.1 }}
            placeholder="Search"
            inputProps={{ 'aria-label': 'search' }}
            value={keywords}
            onChange={handleChange}
        />
        <IconButton
            disabled={!keywords}
            onClick={clearInput}
            type="button"
            sx={{ p: '10px' }}
            aria-label="clear"
        >
            <ClearIcon />
        </IconButton>
        </Paper>
    );
}

export default SearchBox;